export default objectType => {
  return {
    id: `${objectType}.locationId`,
    name: `${objectType}.locationId`,
    displayName: 'View in Location',
    valueType: 'string',
    objectType,
    get: obj => {
      return obj?.data?.location?.id;
    }
  };
};